<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="card">
    <div class="text-xl font-semibold mb-4">Two-Factor Authentication</div>

    <ng-container *ngIf="state === 'loading'">
        <span class="text-muted-color">Loading...</span>
    </ng-container>

    <ng-container *ngIf="state === 'disabled'">
        <p class="text-muted-color mb-4">
            Two-factor authentication adds a second step (a 6-digit code from an authenticator app) when you sign in.
            It is currently <b>disabled</b> for your account.
        </p>
        <button pButton type="button" label="Enable Two-Factor Authentication" icon="pi pi-shield"
            (click)="startSetup()" [loading]="isBusy"></button>
    </ng-container>

    <ng-container *ngIf="state === 'settingUp'">
        <p class="text-muted-color mb-4">
            Scan this QR code with an authenticator app (Google Authenticator, Microsoft Authenticator, Authy, ...),
            then enter the 6-digit code it shows to confirm setup.
        </p>

        <div class="flex flex-col md:flex-row gap-6 mb-4">
            <img *ngIf="qrDataUrl" [src]="qrDataUrl" alt="Two-factor authentication QR code" width="200" height="200" />
            <div class="flex flex-col justify-center">
                <span class="text-sm text-muted-color mb-1">Can't scan the code? Enter this key manually:</span>
                <code class="text-sm break-all">{{ secret }}</code>
            </div>
        </div>

        <label for="confirmCode" class="block font-medium mb-2">Verification code</label>
        <input pInputText id="confirmCode" type="text" inputmode="numeric" maxlength="6" placeholder="123456"
            class="w-full md:w-64 mb-4" [(ngModel)]="confirmCode" name="confirmCode" />

        <div class="flex gap-2">
            <button pButton type="button" label="Confirm" icon="pi pi-check" (click)="confirmSetup()"
                [disabled]="!confirmCode" [loading]="isBusy"></button>
            <button pButton type="button" label="Cancel" icon="pi pi-times" class="p-button-outlined p-button-secondary"
                (click)="cancelSetup()" [disabled]="isBusy"></button>
        </div>
    </ng-container>

    <ng-container *ngIf="state === 'enabled'">
        <p class="text-muted-color mb-4">
            <i class="pi pi-check-circle text-green-500 mr-2"></i>
            Two-factor authentication is <b>enabled</b> for your account.
        </p>
        <button pButton type="button" label="Disable Two-Factor Authentication" icon="pi pi-shield"
            class="p-button-outlined p-button-danger" (click)="confirmDisable($event)" [loading]="isBusy"></button>
    </ng-container>
</div>
